import 'javascripts/application'

import jquery from 'jquery'
import 'bootstrap'
import Popper from 'popper.js'
import Tether from 'tether'

window.$ = window.jQuery = jquery
window.Popper = Popper
window.Tether = Tether
